import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { Button } from "@mui/material";
import { useEffect, useRef } from "react";

const ShowImageModal = ({ setIsOpen, src, title }) => {
  const ref = useRef();
  useEffect(() => {
    const clickFn = (e) => {
      if (ref && ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    window.addEventListener("click", clickFn);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("click", clickFn);
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 50,
        height: "100vh",
        width: "100wh",
        backdropFilter: "brightness(0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "50vw",
          height: "60vh",
          opacity: 1,
          background: "white",
          position: "relative",
          padding: "30px",
          borderRadius: "20px",
        }}
        ref={ref}
      >
        <Button
          sx={{
            marginLeft: "auto",
            position: "absolute",
            top: "1%",
            right: "1%",
            border: "none",
            background: "transparent",
            color: "var(--gray-950)",

            "&:hover": { background: "var(--gray-100)" },
          }}
          onClick={() => setIsOpen(false)}
        >
          <CloseOutlinedIcon />
        </Button>
        <img
          src={src}
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
          alt={title}
        />
      </div>
    </div>
  );
};
export default ShowImageModal;
